import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ed7f604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "match-analysis-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Match Analysis", -1))
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "content-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-state-icon mb-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bar-chart display-1 text-muted" })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, "No Match Analysis Yet", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-4" }, " Select a resume and click analyze to see how well it matches this role. ", -1))
const _hoisted_11 = { class: "resume-dropdown-wrapper mb-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-2" }, "Select Resume", -1))
const _hoisted_13 = {
  key: 0,
  class: "text-center py-2"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading resumes...")
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "text-center py-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "No resumes found. Please create a resume first.", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_22 = {
  key: 1,
  class: "bi bi-magic me-2"
}
const _hoisted_23 = { class: "overall-score-card" }
const _hoisted_24 = {
  key: 0,
  class: "analyze-button"
}
const _hoisted_25 = { class: "resume-dropdown-wrapper mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-2" }, "Select Resume", -1))
const _hoisted_27 = {
  key: 0,
  class: "text-center py-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading resumes...")
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "text-center py-2"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "No resumes found. Please create a resume first.", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 2 }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_36 = {
  key: 1,
  class: "score-content"
}
const _hoisted_37 = { class: "score-details" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Overall Match", -1))
const _hoisted_39 = { class: "score-stats" }
const _hoisted_40 = {
  key: 0,
  class: "stat"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Keywords", -1))
const _hoisted_42 = {
  key: 1,
  class: "stat"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Skills", -1))
const _hoisted_44 = {
  key: 2,
  class: "stat"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Experience", -1))
const _hoisted_46 = {
  key: 3,
  class: "stat"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Education", -1))
const _hoisted_48 = {
  key: 4,
  class: "stat"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Cultural", -1))
const _hoisted_50 = { class: "score-gauge" }
const _hoisted_51 = { class: "score-summary" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1))
const _hoisted_53 = { class: "reanalyze-section mt-4 pt-4 border-top" }
const _hoisted_54 = { class: "d-flex align-items-center justify-content-center gap-3 flex-wrap" }
const _hoisted_55 = {
  class: "resume-dropdown-wrapper",
  style: {"min-width":"300px"}
}
const _hoisted_56 = {
  key: 0,
  class: "text-center py-2"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-border-sm",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading resumes...")
], -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "text-center py-2"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, "No resumes found", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_65 = {
  key: 1,
  class: "bi bi-arrow-repeat me-2"
}
const _hoisted_66 = { class: "analysis-sections" }
const _hoisted_67 = { class: "header-left" }
const _hoisted_68 = { class: "header-content" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Keyword Match", -1))
const _hoisted_70 = { class: "summary" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "section-content" }
const _hoisted_74 = { class: "keyword-stats" }
const _hoisted_75 = { class: "stat-card" }
const _hoisted_76 = { class: "stat-number" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Keywords Found", -1))
const _hoisted_78 = { class: "keyword-grid" }
const _hoisted_79 = { class: "keyword-status" }
const _hoisted_80 = { class: "keyword-content" }
const _hoisted_81 = { class: "keyword-term" }
const _hoisted_82 = {
  key: 0,
  class: "keyword-location"
}
const _hoisted_83 = {
  key: 1,
  class: "keyword-action"
}
const _hoisted_84 = ["onClick"]
const _hoisted_85 = { class: "header-left" }
const _hoisted_86 = { class: "header-content" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Skills Match", -1))
const _hoisted_88 = { class: "summary" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "section-content" }
const _hoisted_92 = { class: "keyword-stats" }
const _hoisted_93 = { class: "stat-card" }
const _hoisted_94 = { class: "stat-number" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Skills Found", -1))
const _hoisted_96 = { class: "keyword-grid" }
const _hoisted_97 = { class: "keyword-status" }
const _hoisted_98 = { class: "keyword-content" }
const _hoisted_99 = { class: "keyword-term" }
const _hoisted_100 = {
  key: 0,
  class: "keyword-location"
}
const _hoisted_101 = {
  key: 1,
  class: "keyword-action"
}
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "header-left" }
const _hoisted_104 = { class: "header-content" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Experience Match", -1))
const _hoisted_106 = { class: "summary" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = { class: "section-content" }
const _hoisted_110 = { class: "keyword-stats" }
const _hoisted_111 = { class: "stat-card" }
const _hoisted_112 = { class: "stat-number" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Experience Items Found", -1))
const _hoisted_114 = { class: "keyword-grid" }
const _hoisted_115 = { class: "keyword-status" }
const _hoisted_116 = { class: "keyword-content" }
const _hoisted_117 = { class: "keyword-term" }
const _hoisted_118 = {
  key: 0,
  class: "keyword-location"
}
const _hoisted_119 = {
  key: 1,
  class: "keyword-action"
}
const _hoisted_120 = ["onClick"]
const _hoisted_121 = { class: "header-left" }
const _hoisted_122 = { class: "header-content" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Education Match", -1))
const _hoisted_124 = { class: "summary" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = { class: "section-content" }
const _hoisted_128 = { class: "keyword-stats" }
const _hoisted_129 = { class: "stat-card" }
const _hoisted_130 = { class: "stat-number" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Education Requirements Met", -1))
const _hoisted_132 = { class: "keyword-grid" }
const _hoisted_133 = { class: "keyword-status" }
const _hoisted_134 = { class: "keyword-content" }
const _hoisted_135 = { class: "keyword-term" }
const _hoisted_136 = {
  key: 0,
  class: "keyword-location"
}
const _hoisted_137 = {
  key: 1,
  class: "keyword-action"
}
const _hoisted_138 = ["onClick"]
const _hoisted_139 = { class: "header-left" }
const _hoisted_140 = { class: "header-content" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cultural Fit Match", -1))
const _hoisted_142 = { class: "summary" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" }, null, -1))
const _hoisted_144 = [
  _hoisted_143
]
const _hoisted_145 = { class: "section-content" }
const _hoisted_146 = { class: "keyword-stats" }
const _hoisted_147 = { class: "stat-card" }
const _hoisted_148 = { class: "stat-number" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Cultural Values Aligned", -1))
const _hoisted_150 = { class: "keyword-grid" }
const _hoisted_151 = { class: "keyword-status" }
const _hoisted_152 = { class: "keyword-content" }
const _hoisted_153 = { class: "keyword-term" }
const _hoisted_154 = {
  key: 0,
  class: "keyword-location"
}
const _hoisted_155 = {
  key: 1,
  class: "keyword-action"
}
const _hoisted_156 = ["onClick"]

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import BreadcrumbNav from "@/components/BreadcrumbNav.vue";
import Gauge from "@/components/Gauge.vue";
import TipsModal from "@/components/TipsModal.vue";
import ResumeDropdown from "@/components/resume-editor/ResumeDropdown.vue";
import { ApplicationApiService } from "@/services/ApplicationApiService";
import { DocumentApiService } from "@/services/DocumentApiService";
import store from "@/store";
import type { ResumeListItem } from "../../../server/src/models/dtos/ResumesList";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

// Interfaces
interface Resource {
  title: string;
  url: string;
  type: string;
}

interface TipsData {
  title: string;
  tips: string[];
  type: string;
  resources: Resource[];
  importance?: string;
}

interface BaseMatchData {
  term: string;
  included: boolean;
  tips: TipsData;
}

interface EducationData extends BaseMatchData {
  term: string;
  included: boolean;
  tips: TipsData;
}

interface KeywordData extends BaseMatchData {
  location?: string;
}

interface SkillData extends BaseMatchData {
  location?: string;
}

interface ExperienceData extends BaseMatchData {
  location?: string;
}

interface CulturalData extends BaseMatchData {
  location?: string;
}

interface MatchData {
  skillsMatch: number;
  experienceMatch: number;
  keywordMatch: number;
  educationMatch: number;
  culturalFitMatch: number;
}

interface ApplicationData {
  id: number | null;
  userId: string;
  companyName: string;
  roleTitle: string;
  jobDescription: string;
  companyDescription: string;
  roleComments: string;
  applicationStatus: number;
  index: number;
  location: string;
  postedDate: string;
  salary: string;
  maxSalary: string;
  sourcedFrom: string;
  jobUrl: string;
  isRemote: boolean;
}

// Interfaces
interface ExpandedSections {
  skills: boolean;
  experience: boolean;
  keywords: boolean;
  education: boolean;
  cultural: boolean;
}

// State

export default /*#__PURE__*/_defineComponent({
  __name: 'MatchAnalysis',
  setup(__props) {

const analyzed = ref(false);
const expandedSections = ref<ExpandedSections>({
  experience: false,
  skills: false,
  keywords: true,
  education: false,
  cultural: false,
});

// Resume selection state
const resumes = ref<ResumeListItem[]>([]);
const selectedResumeId = ref<string | null>(null);
const loadingResumes = ref(false);

const application = ref<ApplicationData>({} as ApplicationData);
const route = useRoute();
const router = useRouter();

const matchData = ref({
  keywordMatch: 0,
  skillsMatch: 0,
  experienceMatch: 0,
  educationMatch: 0,
  culturalFitMatch: 0,
});

const keywordMatchData = ref<KeywordData[]>([]);
const skillMatchData = ref<SkillData[]>([]);
const experienceMatchData = ref<ExperienceData[]>([]);
const educationMatchData = ref<EducationData[]>([]);
const culturalMatchData = ref<CulturalData[]>([]);

const isLoading = ref(false);

// Add new state for initial loading
const isInitialLoading = ref(true);

// Helper functions
const calculateMatchPercentage = (included: number, total: number) => {
  if (total === 0) return 0;
  return Math.max(0, Math.round((included / total) * 100));
};

const processAnalysisData = (data: any) => {
  // Update match data with calculated percentages
  matchData.value = {
    keywordMatch:
      !data.keywordMatchData ||
      !Array.isArray(data.keywordMatchData) ||
      data.keywordMatchData.length === 0
        ? -1
        : calculateMatchPercentage(
            data.keywordMatchData.filter((k: KeywordData) => k.included).length,
            data.keywordMatchData.length
          ),
    skillsMatch:
      !data.skillMatchData ||
      !Array.isArray(data.skillMatchData) ||
      data.skillMatchData.length === 0
        ? -1
        : calculateMatchPercentage(
            data.skillMatchData.filter((s: SkillData) => s.included).length,
            data.skillMatchData.length
          ),
    experienceMatch:
      !data.experienceMatchData ||
      !Array.isArray(data.experienceMatchData) ||
      data.experienceMatchData.length === 0
        ? -1
        : calculateMatchPercentage(
            data.experienceMatchData.filter((e: ExperienceData) => e.included).length,
            data.experienceMatchData.length
          ),
    educationMatch:
      !data.educationMatchData ||
      !data.educationMatchData.term ||
      data.educationMatchData.term === ""
        ? -1
        : data.educationMatchData.included
        ? 100
        : 0,
    culturalFitMatch:
      !data.culturalMatchData ||
      !Array.isArray(data.culturalMatchData) ||
      data.culturalMatchData.length === 0
        ? -1
        : calculateMatchPercentage(
            data.culturalMatchData.filter((c: CulturalData) => c.included).length,
            data.culturalMatchData.length
          ),
  };

  // Store the raw data for tips display
  keywordMatchData.value = Array.isArray(data.keywordMatchData) ? data.keywordMatchData : [];
  skillMatchData.value = Array.isArray(data.skillMatchData) ? data.skillMatchData : [];
  experienceMatchData.value = Array.isArray(data.experienceMatchData)
    ? data.experienceMatchData
    : [];
  culturalMatchData.value = Array.isArray(data.culturalMatchData) ? data.culturalMatchData : [];
  educationMatchData.value = data.educationMatchData || {
    term: "",
    included: false,
    tips: {
      title: "",
      tips: [],
      type: "education",
      resources: [],
    },
  };

  analyzed.value = true;
};

async function analyzeResume() {
  if (!selectedResumeId.value) {
    toast.error("Please select a resume first");
    return;
  }

  try {
    isLoading.value = true;
    const applicationId = route.params.id as string;
    const response = await ApplicationApiService.generateApplicationAnalysis(
      applicationId,
      selectedResumeId.value
    );

    if (response.status === 200) {
      processAnalysisData(response.data);
    }
  } catch (error) {
    console.error("Failed to analyze resume:", error);
  } finally {
    isLoading.value = false;
  }
}

// Fetch resumes
async function fetchResumes() {
  loadingResumes.value = true;
  try {
    const response = await DocumentApiService.getUserResumes();
    resumes.value = response.data.map((resume: any) => ({
      ...resume,
      id: resume.id || crypto.randomUUID(),
      name: resume.name || "Untitled Resume",
      lastModified: resume.lastModified ? new Date(resume.lastModified) : new Date(),
      previewUrl: resume.previewUrl || null,
    }));

    // If there's at least one resume, select the first one by default
    if (resumes.value.length > 0) {
      selectedResumeId.value = resumes.value[0].id;
    }
  } catch (error) {
    console.error("Error fetching resumes:", error);
  } finally {
    loadingResumes.value = false;
  }
}

// Computed properties to determine if charts should be shown
const shouldShowSkillsChart = computed(() => {
  return matchData.value.skillsMatch > 0 && skillMatchData.value.length > 0;
});

const shouldShowExperienceChart = computed(() => {
  return matchData.value.experienceMatch > 0 && experienceMatchData.value.length > 0;
});

const matchedKeywordsCount = computed(
  () => keywordMatchData.value.filter((k) => k.included).length || 0
);
const totalKeywords = computed(() => keywordMatchData.value.length || 0);

const matchedSkillsCount = computed(
  () => skillMatchData.value.filter((s) => s.included).length || 0
);
const totalSkills = computed(() => skillMatchData.value.length || 0);

const matchedExperienceCount = computed(
  () => experienceMatchData.value.filter((e) => e.included).length || 0
);
const totalExperience = computed(() => experienceMatchData.value.length || 0);

const matchedEducationCount = computed(() => {
  if (!educationMatchData.value.term) return 0;
  return educationMatchData.value?.included ? 1 : 0;
});

const totalEducation = computed(() => {
  return educationMatchData.value.term ? 1 : 0;
});

const matchedCulturalCount = computed(
  () => culturalMatchData.value.filter((c) => c.included).length || 0
);
const totalCultural = computed(() => culturalMatchData.value.length || 0);

const hasKeywordRequirements = computed(() => true);
const hasSkillRequirements = computed(() => true);
const hasExperienceRequirements = computed(() => true);
const hasEducationRequirements = computed(() => true);
const hasCulturalRequirements = computed(() => true);

const overallScore = computed(() => {
  const scores = [];

  if (matchData.value.keywordMatch !== -1) {
    scores.push(matchData.value.keywordMatch);
  }
  if (matchData.value.skillsMatch !== -1) {
    scores.push(matchData.value.skillsMatch);
  }
  if (matchData.value.experienceMatch !== -1) {
    scores.push(matchData.value.experienceMatch);
  }
  if (matchData.value.educationMatch !== -1) {
    scores.push(matchData.value.educationMatch);
  }
  if (matchData.value.culturalFitMatch !== -1) {
    scores.push(matchData.value.culturalFitMatch);
  }

  return scores.length > 0 ? Math.round(scores.reduce((a, b) => a + b, 0) / scores.length) : -1;
});

// Computed Properties
const getSkillsSummary = computed(() => {
  if (skillMatchData.value.length === 0) return "No skill requirements specified";
  const score = matchData.value.skillsMatch;
  if (score >= 80) return "Excellent match with required skills";
  if (score >= 60) return "Good match with most key skills";
  if (score >= 40) return "Some matching skills, room for improvement";
  return "Limited skill match, consider upskilling";
});

const getExperienceSummary = computed(() => {
  if (experienceMatchData.value.length === 0) return "No experience requirements specified";
  const score = matchData.value.experienceMatch;
  if (score >= 80) return `Excellent match with relevant experience`;
  if (score >= 60) return "Good match with relevant experience";
  if (score >= 40) return "Some relevant experience";
  return "More experience needed for this role";
});

const getKeywordSummary = computed(() => {
  if (keywordMatchData.value.length === 0) return "No keyword requirements specified";
  const found = matchedKeywordsCount.value;
  const total = totalKeywords.value;
  return `${found} of ${total} key terms found in your profile`;
});

const getEducationSummary = computed(() => {
  if (!educationMatchData.value.term) {
    return "No education requirements specified";
  }
  return educationMatchData.value.included
    ? "Education requirements met"
    : "Additional education may be needed";
});

const getCulturalSummary = computed(() => {
  if (culturalMatchData.value.length === 0) return "No cultural requirements specified";
  const score = matchData.value.culturalFitMatch;
  if (score >= 80) return "Strong cultural alignment";
  if (score >= 60) return "Good cultural fit";
  if (score >= 40) return "Some cultural differences";
  return "Cultural fit needs evaluation";
});

const getOverallMatchLabel = computed(() => {
  const score = overallScore.value;
  if (score === -1) return "Not Available";
  if (score >= 80) return "Excellent Match";
  if (score >= 60) return "Good Match";
  if (score >= 40) return "Fair Match";
  return "Low Match";
});

const getOverallSummary = computed(() => {
  const score = overallScore.value;
  if (score === -1) return "Not enough data to calculate overall match score.";
  if (score >= 80)
    return "You are an excellent fit for this role. Your skills and experience align very well with the requirements.";
  if (score >= 60)
    return "You are a good match for this role, with some areas that could be strengthened.";
  if (score >= 40)
    return "You meet some of the requirements, but there are several areas that need development.";
  return "Consider developing more relevant skills and experience before applying for similar roles.";
});

// Methods
const toggleSection = (section: keyof ExpandedSections) => {
  expandedSections.value[section] = !expandedSections.value[section];
};

const getScoreClass = (score: number) => {
  if (score === -1) return "na";
  if (score >= 80) return "score-high";
  if (score >= 60) return "score-medium";
  if (score >= 40) return "score-fair";
  return "score-needs-improvement";
};

// Utility function to convert string to Title Case with preserved spaces
const toTitleCase = (str: string | undefined | null) => {
  if (!str) return "";
  return str
    .split(/[-_]+/) // Only split on hyphens and underscores
    .join(" ") // Join with spaces
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" "); // Preserve spaces between words
};

// Tips modal state
const showTipsModal = ref(false);
const tipsData = ref<TipsData>({
  title: "",
  tips: [],
  resources: [],
  type: "",
});

const closeTipsModal = () => {
  showTipsModal.value = false;
};

const getTipsForSkill = (skill: SkillData): TipsData => {
  return {
    title: skill.tips.title,
    tips: skill.tips.tips,
    resources: skill.tips.resources,
    importance: skill.tips.importance,
    type: "skill",
  };
};

const getTipsForExperience = (exp: ExperienceData): TipsData => {
  return {
    title: exp.tips.title,
    tips: exp.tips.tips,
    resources: exp.tips.resources,
    type: "experience",
    importance: exp.tips.importance,
  };
};

const getTipsForEducation = (edu: EducationData): TipsData => {
  return {
    title: edu.tips.title,
    tips: edu.tips.tips,
    resources: edu.tips.resources,
    type: "education",
    importance: edu.tips.importance,
  };
};

const getTipsForKeyword = (keyword: KeywordData): TipsData => {
  return {
    title: keyword.tips.title,
    tips: keyword.tips.tips,
    resources: keyword.tips.resources,
    type: "keyword",
    importance: keyword.tips.importance,
  };
};

const getTipsForCulturalValue = (value: CulturalData): TipsData => {
  return {
    title: value.tips.title,
    tips: value.tips.tips,
    resources: value.tips.resources,
    type: "cultural",
    importance: value.tips.importance,
  };
};

const showSkillTips = (skill: SkillData): void => {
  tipsData.value = getTipsForSkill(skill);
  showTipsModal.value = true;
};

const showExperienceTips = (exp: ExperienceData): void => {
  tipsData.value = getTipsForExperience(exp);
  showTipsModal.value = true;
};

const showEducationTips = (edu: EducationData): void => {
  tipsData.value = getTipsForEducation(edu);
  showTipsModal.value = true;
};

const showCulturalTips = (value: CulturalData): void => {
  tipsData.value = getTipsForCulturalValue(value);
  showTipsModal.value = true;
};

const showKeywordTips = (keyword: KeywordData): void => {
  tipsData.value = getTipsForKeyword(keyword);
  showTipsModal.value = true;
};

// Function to handle resource click
const handleResourceClick = (resourceType: string) => {
  router.push(`/resources/${resourceType.toLowerCase().replace(/\s+/g, "-")}`);
};

// Load existing analysis data when component mounts
onMounted(async () => {
  try {
    isInitialLoading.value = true;
    store.dispatch("toggleLoader", true);
    isLoading.value = true;

    // Fetch resumes
    await fetchResumes();

    const applicationId = route.params.id as string;
    const [appResponse, analysisResponse] = await Promise.all([
      ApplicationApiService.getApplicationById(applicationId),
      ApplicationApiService.getApplicationAnalysisById(applicationId),
    ]);

    application.value = {
      id: appResponse.data.id || null,
      userId: appResponse.data.userId || "",
      companyName: appResponse.data.companyName || "",
      roleTitle: appResponse.data.roleTitle || "",
      jobDescription: appResponse.data.jobDescription || "",
      companyDescription: appResponse.data.companyDescription || "",
      roleComments: appResponse.data.roleComments || "",
      applicationStatus: appResponse.data.applicationStatus || 0,
      index: appResponse.data.index || 0,
      location: appResponse.data.location || "",
      postedDate: appResponse.data.postedDate || "",
      salary: appResponse.data.salary || "",
      maxSalary: appResponse.data.maxSalary || "",
      sourcedFrom: appResponse.data.sourcedFrom || "",
      jobUrl: appResponse.data.jobUrl || "",
      isRemote: appResponse.data.isRemote || false,
    };

    if (analysisResponse.status === 200 && analysisResponse.data) {
      processAnalysisData(analysisResponse.data);
    }
  } catch (error) {
    console.error("Failed to load existing analysis:", error);
  } finally {
    // Add a small delay before removing loading states to ensure smooth transition
    setTimeout(() => {
      store.dispatch("toggleLoader", false);
      isLoading.value = false;
      isInitialLoading.value = false;
    }, 300);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadcrumbNav, {
      "back-link": `/application/${_unref(route).params.id}`,
      "back-text": "Application",
      "current-page": "Match Analysis"
    }, null, 8, ["back-link"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("p", _hoisted_4, " Your resume match analysis with " + _toDisplayString(application.value.roleTitle) + " at " + _toDisplayString(application.value.companyName), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["loading-overlay", { visible: isLoading.value }])
          }, _hoisted_7, 2),
          (!analyzed.value && !isInitialLoading.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["empty-state text-center py-5", { loading: isLoading.value }])
              }, [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  (loadingResumes.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                    : (resumes.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(ResumeDropdown, {
                            modelValue: selectedResumeId.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedResumeId).value = $event)),
                            resumes: resumes.value
                          }, null, 8, ["modelValue", "resumes"])
                        ]))
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: analyzeResume,
                  disabled: isLoading.value || !selectedResumeId.value
                }, [
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                    : (_openBlock(), _createElementBlock("i", _hoisted_22)),
                  _createElementVNode("span", null, _toDisplayString(isLoading.value ? "Analyzing..." : "Analyze Resume Match"), 1)
                ], 8, _hoisted_20)
              ], 2))
            : (!isInitialLoading.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["analysis-content", { loading: isLoading.value }])
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    (!analyzed.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            (loadingResumes.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                              : (resumes.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                                : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createVNode(ResumeDropdown, {
                                      modelValue: selectedResumeId.value,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedResumeId).value = $event)),
                                      resumes: resumes.value
                                    }, null, 8, ["modelValue", "resumes"])
                                  ]))
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: analyzeResume,
                            disabled: isLoading.value || !selectedResumeId.value
                          }, [
                            (isLoading.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(isLoading.value ? "Analyzing..." : "Analyze Resume Match"), 1)
                          ], 8, _hoisted_34)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, [
                              (hasKeywordRequirements.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _hoisted_41,
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["stat-value", getScoreClass(matchData.value.keywordMatch)])
                                    }, _toDisplayString(matchData.value.keywordMatch === -1 ? "N/A" : `${matchData.value.keywordMatch}%`), 3)
                                  ]))
                                : _createCommentVNode("", true),
                              (hasSkillRequirements.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _hoisted_43,
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["stat-value", getScoreClass(matchData.value.skillsMatch)])
                                    }, _toDisplayString(matchData.value.skillsMatch === -1 ? "N/A" : `${matchData.value.skillsMatch}%`), 3)
                                  ]))
                                : _createCommentVNode("", true),
                              (hasExperienceRequirements.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _hoisted_45,
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["stat-value", getScoreClass(matchData.value.experienceMatch)])
                                    }, _toDisplayString(matchData.value.experienceMatch === -1 ? "N/A" : `${matchData.value.experienceMatch}%`), 3)
                                  ]))
                                : _createCommentVNode("", true),
                              (hasEducationRequirements.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _hoisted_47,
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["stat-value", getScoreClass(matchData.value.educationMatch)])
                                    }, _toDisplayString(matchData.value.educationMatch === -1 ? "N/A" : `${matchData.value.educationMatch}%`), 3)
                                  ]))
                                : _createCommentVNode("", true),
                              (hasCulturalRequirements.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _hoisted_49,
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["stat-value", getScoreClass(matchData.value.culturalFitMatch)])
                                    }, _toDisplayString(matchData.value.culturalFitMatch === -1 ? "N/A" : `${matchData.value.culturalFitMatch}%`), 3)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(Gauge, {
                              value: overallScore.value === -1 ? null : overallScore.value,
                              threshold: 75,
                              size: "large"
                            }, null, 8, ["value"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["match-label", getScoreClass(overallScore.value)])
                            }, _toDisplayString(getOverallMatchLabel.value), 3)
                          ])
                        ])),
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createTextVNode(" " + _toDisplayString(getOverallSummary.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          (loadingResumes.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                            : (resumes.value.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                              : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _createVNode(ResumeDropdown, {
                                    modelValue: selectedResumeId.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedResumeId).value = $event)),
                                    resumes: resumes.value
                                  }, null, 8, ["modelValue", "resumes"])
                                ]))
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: analyzeResume,
                          disabled: isLoading.value || !selectedResumeId.value
                        }, [
                          (isLoading.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                            : (_openBlock(), _createElementBlock("i", _hoisted_65)),
                          _createElementVNode("span", null, _toDisplayString(isLoading.value ? "Analyzing..." : "Reanalyze"), 1)
                        ], 8, _hoisted_63)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    (hasKeywordRequirements.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["analysis-section", { expanded: expandedSections.value.keywords }])
                        }, [
                          _createElementVNode("div", {
                            class: "section-header",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSection('keywords')))
                          }, [
                            _createElementVNode("div", _hoisted_67, [
                              _createVNode(Gauge, {
                                value: matchData.value.keywordMatch === -1 ? null : matchData.value.keywordMatch,
                                threshold: 75
                              }, null, 8, ["value"]),
                              _createElementVNode("div", _hoisted_68, [
                                _hoisted_69,
                                _createElementVNode("p", _hoisted_70, _toDisplayString(getKeywordSummary.value), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["expand-icon", { expanded: expandedSections.value.keywords }])
                            }, _hoisted_72, 2)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, _toDisplayString(matchedKeywordsCount.value), 1),
                                _hoisted_77
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keywordMatchData.value, (keyword, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["keyword-card", { missing: !keyword.included }])
                                }, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(
                          keyword.included ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill'
                        )
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("div", _hoisted_81, _toDisplayString(toTitleCase(keyword.term)), 1),
                                    (keyword.included)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                          _createElementVNode("span", null, "Found in " + _toDisplayString(keyword.location), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (showKeywordTips(keyword)), ["prevent"])
                                          }, " How to add this keyword → ", 8, _hoisted_84)
                                        ]))
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ], 512), [
                            [_vShow, expandedSections.value.keywords]
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    (hasSkillRequirements.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["analysis-section", { expanded: expandedSections.value.skills }])
                        }, [
                          _createElementVNode("div", {
                            class: "section-header",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSection('skills')))
                          }, [
                            _createElementVNode("div", _hoisted_85, [
                              _createVNode(Gauge, {
                                value: matchData.value.skillsMatch === -1 ? null : matchData.value.skillsMatch,
                                threshold: 75
                              }, null, 8, ["value"]),
                              _createElementVNode("div", _hoisted_86, [
                                _hoisted_87,
                                _createElementVNode("p", _hoisted_88, _toDisplayString(getSkillsSummary.value), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["expand-icon", { expanded: expandedSections.value.skills }])
                            }, _hoisted_90, 2)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("div", _hoisted_94, _toDisplayString(matchedSkillsCount.value), 1),
                                _hoisted_95
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skillMatchData.value, (skill, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["keyword-card", { missing: !skill.included }])
                                }, [
                                  _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(skill.included ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill')
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_98, [
                                    _createElementVNode("div", _hoisted_99, _toDisplayString(toTitleCase(skill.term)), 1),
                                    (skill.included)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                          _createElementVNode("span", null, "Found in " + _toDisplayString(skill.location), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (showSkillTips(skill)), ["prevent"])
                                          }, " How to add this skill → ", 8, _hoisted_102)
                                        ]))
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ], 512), [
                            [_vShow, expandedSections.value.skills]
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    (hasExperienceRequirements.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass(["analysis-section", { expanded: expandedSections.value.experience }])
                        }, [
                          _createElementVNode("div", {
                            class: "section-header",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSection('experience')))
                          }, [
                            _createElementVNode("div", _hoisted_103, [
                              _createVNode(Gauge, {
                                value: matchData.value.experienceMatch === -1 ? null : matchData.value.experienceMatch,
                                threshold: 75
                              }, null, 8, ["value"]),
                              _createElementVNode("div", _hoisted_104, [
                                _hoisted_105,
                                _createElementVNode("p", _hoisted_106, _toDisplayString(getExperienceSummary.value), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["expand-icon", { expanded: expandedSections.value.experience }])
                            }, _hoisted_108, 2)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("div", _hoisted_112, _toDisplayString(matchedExperienceCount.value), 1),
                                _hoisted_113
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experienceMatchData.value, (exp, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["keyword-card", { missing: !exp.included }])
                                }, [
                                  _createElementVNode("div", _hoisted_115, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(exp.included ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill')
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_116, [
                                    _createElementVNode("div", _hoisted_117, _toDisplayString(toTitleCase(exp.term)), 1),
                                    (exp.included)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                          _createElementVNode("span", null, "Found in " + _toDisplayString(exp.location), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (showExperienceTips(exp)), ["prevent"])
                                          }, " How to add this experience → ", 8, _hoisted_120)
                                        ]))
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ], 512), [
                            [_vShow, expandedSections.value.experience]
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    (hasEducationRequirements.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: _normalizeClass(["analysis-section", { expanded: expandedSections.value.education }])
                        }, [
                          _createElementVNode("div", {
                            class: "section-header",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSection('education')))
                          }, [
                            _createElementVNode("div", _hoisted_121, [
                              _createVNode(Gauge, {
                                value: matchData.value.educationMatch === -1 ? null : matchData.value.educationMatch,
                                threshold: 75
                              }, null, 8, ["value"]),
                              _createElementVNode("div", _hoisted_122, [
                                _hoisted_123,
                                _createElementVNode("p", _hoisted_124, _toDisplayString(getEducationSummary.value), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["expand-icon", { expanded: expandedSections.value.education }])
                            }, _hoisted_126, 2)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, _toDisplayString(matchedEducationCount.value), 1),
                                _hoisted_131
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_132, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(educationMatchData.value, (edu, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["keyword-card", { missing: !edu.included }])
                                }, [
                                  _createElementVNode("div", _hoisted_133, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(edu.included ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill')
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_134, [
                                    _createElementVNode("div", _hoisted_135, _toDisplayString(toTitleCase(edu.term)), 1),
                                    (edu.included)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                          _createElementVNode("span", null, "Found in " + _toDisplayString(edu.location), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (showEducationTips(edu)), ["prevent"])
                                          }, " Add this experience → ", 8, _hoisted_138)
                                        ]))
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ], 512), [
                            [_vShow, expandedSections.value.education]
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    (hasCulturalRequirements.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          class: _normalizeClass(["analysis-section", { expanded: expandedSections.value.cultural }])
                        }, [
                          _createElementVNode("div", {
                            class: "section-header",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSection('cultural')))
                          }, [
                            _createElementVNode("div", _hoisted_139, [
                              _createVNode(Gauge, {
                                value: matchData.value.culturalFitMatch === -1 ? null : matchData.value.culturalFitMatch,
                                threshold: 75
                              }, null, 8, ["value"]),
                              _createElementVNode("div", _hoisted_140, [
                                _hoisted_141,
                                _createElementVNode("p", _hoisted_142, _toDisplayString(getCulturalSummary.value), 1)
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["expand-icon", { expanded: expandedSections.value.cultural }])
                            }, _hoisted_144, 2)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_145, [
                            _createElementVNode("div", _hoisted_146, [
                              _createElementVNode("div", _hoisted_147, [
                                _createElementVNode("div", _hoisted_148, _toDisplayString(matchedCulturalCount.value), 1),
                                _hoisted_149
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_150, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(culturalMatchData.value, (value, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["keyword-card", { missing: !value.included }])
                                }, [
                                  _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(value.included ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill')
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_152, [
                                    _createElementVNode("div", _hoisted_153, _toDisplayString(toTitleCase(value.term)), 1),
                                    (value.included)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                          _createElementVNode("span", null, "Found in " + _toDisplayString(value.location), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (showCulturalTips(value)), ["prevent"])
                                          }, " How to include this value → ", 8, _hoisted_156)
                                        ]))
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ], 512), [
                            [_vShow, expandedSections.value.cultural]
                          ])
                        ], 2))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(TipsModal, {
      "is-open": showTipsModal.value,
      title: tipsData.value.title,
      importance: tipsData.value.importance || '',
      tips: tipsData.value.tips,
      resources: tipsData.value.resources,
      type: tipsData.value.type,
      onClose: closeTipsModal
    }, null, 8, ["is-open", "title", "importance", "tips", "resources", "type"])
  ], 64))
}
}

})